<template>
  <div class="upload-container">
    <!-- Top Image (Centered) -->
    <div v-if="showImageTop && images.length && images[0]['url'] != null" class="image-container centered">
      <div class="preview framed">
        <img :src="defaultImageUrl" alt="PDF Preview" class="avatar" />
        <span v-if="images.length > 0" class="remove-icon" @click="removeImage(0)">×</span>
      </div>
    </div>

    <!-- Upload Button -->
    <div :class="{ 'text-center': showImageTop }">
      <b-button variant="outline-primary" @click="triggerFileInput" class="upload-button">
        {{ buttonText }}
      </b-button>
    </div>

    <!-- Bottom Images (Left-Aligned) -->
    <div v-if="!showImageTop && images.length" class="image-container-row">
      <div v-for="(image, index) in images" :key="index" class="preview framed">
        <img :src="defaultImageUrl" alt="PDF Preview" class="avatar" />
        <span class="remove-icon" @click="removeImage(index)">×</span>
      </div>
    </div>

    <!-- Hidden File Input -->
    <input type="file" ref="fileInput" @change="onFileChange" :multiple="multiple" accept="application/pdf"
      style="display: none;" />
  </div>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    showImageTop: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default: "Upload PDF",
    },
    initialImages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      images: [],
      defaultImageUrl:
        "https://ihextar.s3.ap-southeast-1.amazonaws.com/png-transparent-computer-icons-pdf-document-others-red-and-white-pdf-illustration-thumbnail.png",
    };
  },
  watch: {
    initialImages: {
      immediate: true,
      handler(newVal) {
        this.images = newVal.map((url) => ({ url }));
      },
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const files = event.target.files;
      if (!files.length) return;

      if (!this.multiple) {
        this.images = [];
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          if (this.multiple) {
            this.images.push({ file, url: e.target.result });
          } else {
            this.images = [{ file, url: e.target.result }];
          }
          this.$emit('images-changed', [...this.images]);
        };

        reader.readAsDataURL(file);
      }

      // ✅ Reset input so the same file can be uploaded again later
      this.$refs.fileInput.value = '';
    },
    removeImage(index) {
      this.images.splice(index, 1);

      this.$emit('images-removed', [...this.images]);
      this.$emit('images-changed', [...this.images]);

      // ✅ Reset input so user can reupload same image
      this.$refs.fileInput.value = '';
    }
  },
};
</script>

<style scoped>
.upload-container {
  text-align: left;
}

.image-container.centered {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.image-container-row {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.preview {
  position: relative;
  display: inline-block;
  text-align: center;
  margin-right: 10px;
}

.framed {
  padding: 20px;
  border: 2px solid #ddd;
  border-radius: 10px;
  background-color: white;
}

.preview img {
  max-width: 100px;
  max-height: 100px;
  display: block;
  border-radius: 10px;
}

.remove-icon {
  position: absolute;
  bottom: 5px;
  right: 5px;
  color: white;
  background-color: red;
  border-radius: 50%;
  cursor: pointer;
  padding: 2px 5px;
  font-size: 16px;
  line-height: 16px;
}

.upload-button {
  margin-bottom: 10px;
}
</style>
